import { render, staticRenderFns } from "./StationPlaces.vue?vue&type=template&id=daa96af4&scoped=true&"
import script from "./StationPlaces.vue?vue&type=script&lang=js&"
export * from "./StationPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa96af4",
  null
  
)

/* custom blocks */
import block0 from "./StationPlaces.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daa96af4')) {
      api.createRecord('daa96af4', component.options)
    } else {
      api.reload('daa96af4', component.options)
    }
    module.hot.accept("./StationPlaces.vue?vue&type=template&id=daa96af4&scoped=true&", function () {
      api.rerender('daa96af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaces/StationPlaces.vue"
export default component.exports